import { M8ProductType } from 'services/production/types';
import { getM8AdminURL } from 'services/production/utils/getM8URL';
import { HTTPResponseError } from 'utils/errors';
import { appendFormDataWithObjectValues, customFetch } from 'utils/http';

type Params = {
  productType: M8ProductType;
  comission: number;
};

export const setDefaultPartnerComissionFor = async (
  params: Params
): Promise<void> => {
  const body = new FormData();
  appendFormDataWithObjectValues(body, params);

  const response = await customFetch(
    getM8AdminURL('setDefaultPartnerComissionFor'),
    {
      method: 'POST',
      body,
    }
  );

  if (!response.ok) {
    throw new HTTPResponseError(response);
  }
};
